import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (user_id, password) => {
    const r = await api.post("/auth/login", { user_id, password });
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  const can = (module, action = "view") => {
    if (!user || user === false) return false;
    if (user.role === "admin") return true;
    return !!user.permissions?.[module]?.[action];
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, can, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
